import React, { useLayoutEffect, useRef } from "react";
import {
  Building2,
  Users,
  Package,
  Shield,
  BarChart3,
  Settings,
  Menu,
  ShieldCheck,
} from "lucide-react";
import { NavLink, Outlet, useLocation } from "react-router-dom";

const tabs = [
  { path: "/admin", label: "Dashboard", icon: BarChart3 },
  { path: "/admin/companies", label: "Companies", icon: Building2 },
  { path: "/admin/users", label: "Users", icon: Users },
  { path: "/admin/base_modules", label: "Modules", icon: Package },
  { path: "/admin/roles", label: "Roles", icon: Shield },
  { path: "/admin/base_navigations", label: "Navigations", icon: Menu },
  {
    path: "/admin/nav_visibility",
    label: "Nav Visibilitly",
    icon: ShieldCheck,
  },
];

const AdminLayout = () => {
  const { pathname } = useLocation();
  const contentRef = useRef(null);

  // useLayoutEffect fires synchronously BEFORE browser paint
  // so the scroll resets before the user ever sees the new page
  useLayoutEffect(() => {
    contentRef.current?.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="flex flex-col bg-slate-100 dark:bg-slate-900 overflow-hidden h-[calc(100vh-56px)]">
      {/* Header */}
      <header className="flex-shrink-0 bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700 z-10">
        {/* Top Bar */}
        <div className="px-6 py-3.5 flex items-center justify-between">
          <h1 className="text-xl font-bold text-slate-900 dark:text-white tracking-tight">
            shipez
            <span className="text-teal-500">.ai</span>
            <span className="text-xs ml-2.5 px-2 py-0.5 rounded-full bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400 font-medium">
              Admin
            </span>
          </h1>

          <button className="p-2 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-white">
            <Settings className="w-4.5 h-4.5" />
          </button>
        </div>

        {/* Tabs */}
        <nav className="px-6 flex gap-0.5 overflow-x-auto scrollbar-hide">
          {tabs.map((tab) => (
            <NavLink
              key={tab.path}
              to={tab.path}
              end={tab.path === "/admin"}
              className={({ isActive }) =>
                `px-3.5 py-2.5 flex items-center gap-2 text-sm font-medium border-b-2 transition-all whitespace-nowrap ${
                  isActive
                    ? "text-teal-600 dark:text-teal-400 border-teal-500 dark:border-teal-400 bg-teal-50/60 dark:bg-teal-900/20"
                    : "text-slate-500 dark:text-slate-400 border-transparent hover:text-slate-700 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/50"
                }`
              }
            >
              <tab.icon className="w-4 h-4 flex-shrink-0" />
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </header>

      {/* Scrollable Content — this is the ONLY scroll container */}
      <main ref={contentRef} className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
